



























































































































import { defineComponent, ref, onMounted, computed } from '@vue/composition-api'
import {
  mdiCancel,
  mdiCheckCircleOutline,
  mdiDotsVertical,
  mdiFilterVariantMinus,
  mdiPencilOutline,
  mdiPlus,
  mdiViewListOutline,
} from '@mdi/js'
import useSweetAlert from '@core/plugins/sweetalert'

// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import PaginationFooter from '@shared/components/PaginationFooter.vue'

// Components
import AutoridadFiltro from '../components/AutoridadFiltro.vue'
import AutoridadModal from '../components/AutoridadModal.vue'

import { IResponseElement, AutoridadFiltroModel, AutoridadInterface, Pagination } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import { formatISODate } from '@core/utils/filter'

export default defineComponent({
  components: {
    PaginationSelect,
    PaginationFooter,
    AutoridadFiltro,
    AutoridadModal,
  },
  setup() {
    const isFilterPanelActive = ref(false)
    const mostrarAutoridadModal = ref(false)
    const filtro = ref(new AutoridadFiltroModel())
    const pagination = ref(new Pagination())
    const { confirm, showMessage } = useSweetAlert()

    const { isLoading } = useAppConfig()

    onMounted(() => {
      obtenerAutoridades(filtro.value)
    })

    const filterDate = computed(() => (ISODate: string) => formatISODate(ISODate))

    const obtenerAutoridades = async (filter: AutoridadFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('autoridad/obtenerAutoridades', params)

      if (ok) {
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<AutoridadInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const editarAutoridad = (autoridad: AutoridadInterface) => {
      store.commit('autoridad/cargarAutoridad', autoridad)
      mostrarAutoridadModal.value = true
    }

    const cambiarEstadoAutoridad = async (autoridad: AutoridadInterface) => {
      const { value } = await confirm(
        `¿Está seguro de ${autoridad.habilitado === 'S' ? 'inactivar' : 'habilitar'} la autoridad?`,
        `${autoridad.habilitado === 'S' ? 'danger' : 'success'}`,
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch('autoridad/cambiarEstadoAutoridad', autoridad.autoridadId)

        if (ok) {
          showMessage('Éxito!', response.mensaje, 'success')
          obtenerAutoridades(filtro.value)
        }
        isLoading.value = false
      }
    }

    const autoridadModalOnClose = (actualizar: boolean) => {
      mostrarAutoridadModal.value = false
      if (actualizar) {
        obtenerAutoridades(filtro.value)
      }
    }

    return {
      autoridades: computed<AutoridadInterface[]>(() => store.getters['autoridad/autoridades']),
      autoridadModalOnClose,
      cambiarEstadoAutoridad,
      editarAutoridad,
      filterDate,
      filtro,
      isFilterPanelActive,
      isLoading,
      mostrarAutoridadModal,
      obtenerAutoridades,
      pagination,
      icons: {
        mdiCancel,
        mdiCheckCircleOutline,
        mdiDotsVertical,
        mdiFilterVariantMinus,
        mdiPencilOutline,
        mdiPlus,
        mdiViewListOutline,
      },
    }
  },
})
